module.exports = __webpack_public_path__ + "static/title-mob-2-065d76951c1e7b941a6aeb054abcae7a.png";